import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import Button from '../../components/Button';
import FieldDatepicker from '../../components/FieldDatepicker';
import FieldSelect from '../../components/FieldSelect';
import FieldInput from '../../components/FieldInput';
import FieldRadiobutton from '../../components/FieldRadiobutton';
import ErrorValidation from '../../components/ErrorValidation';
import TooltipItem from "../../components/TooltipItem";
import AverageHoursMessage from "../../components/AverageHoursMessage";
import Link from "../../components/Link";
import {whatsapp} from "../../config/common.json";
import styles from './styles.module.scss';


const Step18View = ({loadOptions, values, isValid}) => {

  return (
    <Form className={styles.formContainer}>
      <div className={styles.contentBlock}>
        <FieldRadiobutton
          fieldId={'EditOrClose'}
          value={'edit'}
          label={(
            <div className={`${styles.grayText} ${styles.bold}`}>
              <FormattedMessage
                id='step18.form.change.label'
                defaultMessage={'A change in income and working hours in the current year'}
              />
            </div>
          )}
        />
      </div>
      {
        values.EditOrClose === 'edit' && (
          <div className={styles.contentBlock}>
            <div className={`${styles.input} ${styles.title}`}>
              <FormattedMessage
                id={'step18.form.were.title'}
                defaultMessage={'there were:'}
              />
            </div>
            <FieldDatepicker
              fieldId={'freelanceStartDate'}
              label={(
                <div className={styles.text}>
                  <FormattedMessage
                    id='step18.form.were.from.label'
                    defaultMessage={'From date'}
                  />
                </div>
              )}
              containerStyles={styles.input}
            />
            <FieldSelect
              fieldId='weeklyAverageWorkHours'
              loadOptions={loadOptions}
              label={(
                <FormattedMessage
                  id='step18.form.hours.label'
                  defaultMessage={'Average working hours per week were'}
                />
              )}
              containerStyles={styles.input}
            />
            <FieldInput
              fieldId='monthlyAverageIncome'
              label={(
                <FormattedMessage
                  id='step18.form.income.label'
                  defaultMessage={'Average monthly income in NIS'}
                />
              )}
              containerStyles={styles.input}
            />
            <div className={`${styles.input} ${styles.title}`}>
              <FormattedMessage
                id={'step18.form.will.title'}
                defaultMessage={'Will:'}
              />
            </div>
            <FieldDatepicker
              fieldId={'willFrom'}
              label={(
                <div className={styles.text}>
                  <FormattedMessage
                    id='step18.form.will.to.label'
                    defaultMessage={'And dated'}
                  />
                </div>
              )}
              containerStyles={styles.input}
            />
            <FieldSelect
              fieldId='willHours'
              loadOptions={loadOptions}
              label={(
                <>
                  <FormattedMessage
                    id='step18.form.hours.label'
                    defaultMessage={'Average working hours per week were'}
                  />
                  <TooltipItem
                    id={'step18.form.hours'}
                    tooltipText={
                      <FormattedMessage
                        id='step18.form.hours.bubble'
                        defaultMessage='Mark how many hours a week you will devote to your work through us.
                    Please note, if you choose the 1-11 hours option,
                    you will be considered as someone who does not work and
                    will only pay the minimum to National Insurance.
                    In addition, you will not be able to receive pensions from National Insurance.'
                      />
                    }
                  />
                </>
              )}
              containerStyles={styles.input}
            />
            <AverageHoursMessage
              value={values.willHours.value}
            />
            <FieldInput
              fieldId='willIncome'
              label={(
                <>
                  <FormattedMessage
                    id='step18.form.income.label'
                    defaultMessage={'Average monthly income in NIS'}
                  />
                  <TooltipItem
                    id={'step18.form.income'}
                    tooltipText={
                      <FormattedMessage
                        id='step18.form.income.bubble'
                        defaultMessage="Enter how much you will earn through us on average per month.
                    According to this determination, you will pay the monthly advance to National Insurance.
                    Don't worry, it can be changed during the year if you earn more or less."
                      />
                    }
                  />
                </>
              )}
              containerStyles={styles.input}
            />
          </div>
        )
      }
      <div className={styles.contentBlock}>
        <FieldRadiobutton
          fieldId={'EditOrClose'}
          value={'close'}
          label={(
            <div className={`${styles.grayText} ${styles.bold}`}>
              <FormattedMessage
                id='step18.form.closingInsurance.label'
                defaultMessage={'Closing a case with the National Insurance Institute'}
              />
            </div>
          )}
        />
        {
          values.EditOrClose === 'close' && (
            <>
              <div className={styles.input}/>
              <FieldDatepicker
                fieldId={'closeDate'}
                label={(
                  <div className={styles.text}>
                    <FormattedMessage
                      id='step18.form.closing.label'
                      defaultMessage={'closing date'}
                    />
                  </div>
                )}
                containerStyles={styles.input}
              />
            </>
          )
        }
      </div>
      <Link
        label={
          <FormattedMessage
            id={'common.whatsapp.link'}
            defaultMessage={'Need help? Click to switch to WhatsApp'}
          />
        }
        link={whatsapp}
        customContainerStyles={styles.innerPadding}
      />
      <div className={styles.innerPadding}>
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
        />
        {!isValid && <ErrorValidation/>}
      </div>
    </Form>
  )
};

Step18View.propTypes = {
  loadOptions: PropTypes.func,
  values: PropTypes.object,
  isValid: PropTypes.bool,
};

export default Step18View;
